<template>
  <form @submit.prevent="$emit('submit')" class="form">
    <h2 class="form-title">{{ title }}</h2>
    <slot />
  </form>
</template>

<script>
export default {
  name: "Form",
  props: {
    title: String
  }
};
</script>

<style scoped>
.form {
  height: 203px;
  display: flex;
  flex-direction: column;
  margin-bottom: var(--gutter);
}

.form-control {
  background: rgb(var(--gray-3));
  color: rgb(var(--text-2));
  border-radius: var(--brs);
  padding: 0.5rem 1rem;
  border: none;
  transition: var(--smooth-fast);
}

.form-control:not(:last-child) {
  margin-bottom: 0.5rem;
}

.form-control:hover {
  background: rgba(var(--gray-3), 0.6);
}

button.form-control {
  background: rgb(var(--accent));
  color: rgb(224, 224, 224);
  align-self: flex-start;
}

button.form-control:hover {
  background: rgba(var(--accent), 0.6);
}
</style>
